export default class DispatchTimezoneEnum {
    public static ALL_DISPATCH_TIMEZONES: Map<string, DispatchTimezoneEnum> = new Map();

    public static STORE_TIMEZONE: DispatchTimezoneEnum = new DispatchTimezoneEnum('STORE_LOCALTIME');
    public static SUBSCRIBER_TIMEZONE: DispatchTimezoneEnum = new DispatchTimezoneEnum('CONSUMER_LOCALTIME');
    public static USER_TIMEZONE: DispatchTimezoneEnum = new DispatchTimezoneEnum('USER_LOCALTIME');

    public static from(value: string): DispatchTimezoneEnum | null {
        return DispatchTimezoneEnum.ALL_DISPATCH_TIMEZONES.get(value) || null;
    }

    public value: string;

    constructor(value: string) {
        this.value = value;

        DispatchTimezoneEnum.ALL_DISPATCH_TIMEZONES.set(value, this);
    }

    public toJSON(): any {
        return this.value;
    }
}
